import { openModalPage, previousModalPage } from 'actions/modalPage';
import { modalPages as mp } from 'constants/modalPage';

const singlePrompt = (
  componentName: 'SearchCouponsModal' | 'TafCustomerSearchModal',
) => async dispatch => {
  return dispatch(
    openModalPage({
      component: mp.pluginModal,
      props: {
        name: componentName,
      },
      isPopup: true,
      modalClassName: componentName === 'TafCustomerSearchModal' ? 'customer-search-input' : undefined,
    }),
  );
};

export const couponsPrompt = () => async dispatch => {
  return dispatch(
    openModalPage({
      component: mp.pluginModal,
      props: {
        name: 'TafCouponsPoints',
        closeModal: () => {
          dispatch(previousModalPage());
        },
        onCancel: () => {
          dispatch(previousModalPage());
        },
      },
      isPopup: true,
    }),
  );
};

export default singlePrompt;
